import styled from 'styled-components';
import { backgroundImage, flex } from '@/styles/minix';
import { colorGroup } from '@/styles/common';

import icoIcon from '@/images/logo.svg';

export const CenterWrap = styled.div`
	height: 100%;
`;
export const SystemWrap = styled.div``;

export const UserProjectWrap = styled.div`
	${flex('row', 'flex-start', '')};
	height: 100%;
	> .left-menu--wrap {
		max-width: 160px;
		min-width: 160px;
		height: 100%;
		${flex('column', 'space-between', 'center')};
		background: ${colorGroup.navColor};

		.top--wrap {
			width: 100%;
			.project-title--wrap {
				${flex('row', 'center', 'center')};
				height: 60px;
				color: ${colorGroup.whiteColor};

				> .icon-ico {
					${backgroundImage(icoIcon, '30px')};
				}
				> h1 {
					font-size: 16px;
					font-weight: 400;
					margin-left: 14px;
					color: ${colorGroup.whiteColor};
				}
			}

			.navs--wrap {
				> a {
					height: 40px;
					box-sizing: border-box;
					padding: 0 0 0 20px;
					${flex('row', '', 'center')};
					font-size: 14px;
					color: #ffffff;
					text-decoration: none;
				}
				& img {
					margin-right: 8px;
					width: 18px;
					height: 18px;
				}
				ul {
					background: #053885;
					.ant-menu-item-selected {
						background: rgba(255, 255, 255, 0.06);
					}
				}

				& .ant-menu-item > .ant-menu-title-content,
				.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
					margin-left: -3px;
				}
				.ant-menu-title-content {
					a {
						display: flex;
						align-items: center;
					}
				}
			}
		}

		.bottom-btns-wrap {
			width: 100%;
			margin-bottom: 20px;
			box-sizing: border-box;
			text-align: center;
			.bottom-btn {
				width: 100%;
				line-height: 34px;
				height: 34px;
				background: rgba(255, 255, 255, 0.2);
				color: #dfecff;
				border-radius: 6px;
				font-size: 12px;
				cursor: pointer;
			}
			.logout-wrap {
				margin-top: 10px;
			}
			.user-wrap {
				width: 100%;
				height: 40px;
				color: #dfecff;
				font-size: 14px;
				display: flex;
				align-items: center;
				gap: 6px;
				justify-content: center;
			}
			.user-wrap-select {
				background: rgba(255, 255, 255, 0.06);
			}
		}
	}
	> .right--wrap {
		flex-grow: 1;
	}
`;
export const UserContentWrap = styled.div`
	padding: 8px 10px;
	.login-wrap,
	.account-wrap {
		cursor: pointer;
		color: #344563;
		font-size: 14px;
		padding: 2px 8px 2px 2px;
	}
	.line {
		margin-top: 10px;
		margin-bottom: 14px;
		height: 1px;
		width: 100%;
		background-color: #e9ebef;
	}
	img {
		margin-right: 8px;
	}
	.select {
		background: #edeff3;
		border-radius: 2px;
	}
`;
